import { analytics } from 'moet-core';
export const ANALYTICS_EVENTS = {
    uploadDocument: new analytics.Event({
        name: 'Document Uploaded',
        description: 'Merchant uploaded a document',
        action: analytics.EVENT_ACTION.FORM_SUBMIT,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: ['documentType'],
        userAttributes: ['documentType'],
        // @ts-expect-error: FIXME
    }),
    deleteDocument: new analytics.Event({
        name: 'Document Deleted',
        description: 'Merchant deleted a document',
        action: analytics.EVENT_ACTION.FORM_SUBMIT,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: ['documentType'],
        userAttributes: ['documentType'],
        // @ts-expect-error: FIXME
    }),
    maxDocumentsAllowedReached: new analytics.Event({
        name: 'Too many documents selected to upload',
        description: 'Merchant selected more than the maximum number of documents allowed',
        action: analytics.EVENT_ACTION.FORM_SUBMIT,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: ['numberOfDocumentsForUpload'],
        userAttributes: ['numberOfDocumentsForUpload'],
        // @ts-expect-error: FIXME
    }),
};
